module.exports = __webpack_public_path__ + "img/ab.e1d4d6b7.png";